module.exports = __webpack_public_path__ + "media/images/icon-svg/instagram-5e586a0c6d762d9136f1787b50e6f8ca.svg";